export default function ({ req, redirect }) {
  let token = null;

  // 서버 사이드에서는 req.headers.cookie에서 쿠키를 확인
  if (process.server && req && req.headers.cookie) {
    const cookieString = req.headers.cookie;
    const tokenMatch = cookieString.match(/(?:^|;\s*)userToken=([^;]+)/);
    if (tokenMatch) {
      token = tokenMatch[1];
    }
  }

  // 클라이언트 사이드에서는 document.cookie에서 확인
  if (process.client) {
    const cookieString = document.cookie;
    const tokenMatch = cookieString.match(/(?:^|;\s*)auth_token=([^;]+)/);
    console.log('auth.js cookie:', cookieString)
    console.log(tokenMatch)
    if (tokenMatch) {
      token = tokenMatch[1];
    }
  }

  if (!token) {
    alert('tokenNotMatch')
    return redirect('/auth/login'); // 토큰 없으면 로그인 페이지로 리다이렉트
  }
}
